import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, TextField, Heading } from "@aws-amplify/ui-react";
import styled from "@emotion/styled";
import PopupWarning from "../components/PopupWarning";
import useContent from "../utils/useContent";
import StartCards from "../components/StartCards";
import CreateCard from "../components/CreateCard";
import AuthorBlock from "../components/AuthorBlock";

/// CSS
const Container = styled("div")`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
`;
const CreateContainer = styled.section`
  display: flex;
  flex-direction: column;
  > button {
    width: fit-content;
  }
`;
const CreatBlock = styled.section`
  display: flex;
  flex-wrap: wrap;
`;
const BlogsContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 50px;
  flex-flow: wrap row;
  margin: 50px 0px;
`;

/// JS
function Main() {
  // fetch data
  const {
    content: weddings,
    formData: formDataWeddings,
    onPopup: onPopupWeddings,
    setOnPopup: setOnPopupWeddings,
    onChange: onChangeWeddings,
    createContent: createWeddings,
    deleteContent: deleteWeddings,
    setFormData: setFormDataWeddings,
  } = useContent("weddings");

  const {
    content: corporate,
    formData: formDataCorporate,
    onPopup: onPopupCorporate,
    setOnPopup: setOnPopupCorporate,
    onChange: onChangeCorporate,
    createContent: createCorporate,
    deleteContent: deleteCorporate,
    setFormData: setFormDataCorporate,
  } = useContent("corporate");

  const {
    content: privateItem,
    formData: formDataPrivateItem,
    onPopup: onPopupPrivateItem,
    setOnPopup: setOnPopupPrivateItem,
    onChange: onChangePrivateItem,
    createContent: createPrivateItem,
    deleteContent: deletePrivateItem,
    setFormData: setFormDataPrivateItem,
  } = useContent("private");

  const {
    content: nonProfit,
    formData: formDataNonProfit,
    onPopup: onPopupNonProfit,
    setOnPopup: setOnPopupNonProfit,
    onChange: onChangeNonProfit,
    createContent: createNonProfit,
    deleteContent: deleteNonProfit,
    setFormData: setFormDataNonProfit,
  } = useContent("nonProfit");

  const {
    content: vip,
    formData: formDataVip,
    onPopup: onPopupVip,
    setOnPopup: setOnPopupVip,
    onChange: onChangeVip,
    createContent: createVip,
    deleteContent: deleteVip,
    setFormData: setFormDataVip,
  } = useContent("vip");

  const [showCreateBlock, setShowCreateBlock] = useState(false);
  const handleClosePopup = () => {
    setOnPopupWeddings("");
  };

  const handleClosePopupCorporate = () => {
    setOnPopupCorporate("");
  };

  const handleClosePopupPrivateItem = () => {
    setOnPopupPrivateItem("");
  };
  const handleClosePopupNonProfit = () => {
    setOnPopupNonProfit("");
  };
  const handleClosePopupVip = () => {
    setOnPopupVip("");
  };
  return (
    <>
      <AuthorBlock />
      <BlogsContainer>
        <StartCards
          content={corporate}
          setOnPopup={setOnPopupCorporate}
          href={"corporate"}
        />
        <StartCards
          content={privateItem}
          setOnPopup={setOnPopupPrivateItem}
          href={"private"}
        />
        <StartCards
          content={weddings}
          setOnPopup={setOnPopupWeddings}
          href={"weddings"}
        />

        <StartCards
          content={nonProfit}
          setOnPopup={setOnPopupNonProfit}
          href={"nonProfit"}
        />
        <StartCards content={vip} setOnPopup={setOnPopupVip} href={"vip"} />
        <PopupWarning
          onPopup={onPopupWeddings}
          handleClosePopup={handleClosePopup}
          onDelete={deleteWeddings}
        />
        <PopupWarning
          onPopup={onPopupCorporate}
          handleClosePopup={handleClosePopupCorporate}
          onDelete={deleteCorporate}
        />
        <PopupWarning
          onPopup={onPopupPrivateItem}
          handleClosePopup={handleClosePopupPrivateItem}
          onDelete={deletePrivateItem}
        />
        <PopupWarning
          onPopup={onPopupNonProfit}
          handleClosePopup={handleClosePopupNonProfit}
          onDelete={deleteNonProfit}
        />
        <PopupWarning
          onPopup={onPopupVip}
          handleClosePopup={handleClosePopupVip}
          onDelete={deleteVip}
        />
      </BlogsContainer>
      <CreateContainer>
        <Button
          variation="link"
          size="small"
          onClick={() => setShowCreateBlock(!showCreateBlock)}
        >
          Show create block
        </Button>
        {showCreateBlock && (
          <CreatBlock>
            <CreateCard
              createSection={createWeddings}
              onChangeImage={onChangeWeddings}
              formData={formDataWeddings}
              setFormData={setFormDataWeddings}
              sectionName={"weddings"}
            />
            <CreateCard
              createSection={createCorporate}
              onChangeImage={onChangeCorporate}
              formData={formDataCorporate}
              setFormData={setFormDataCorporate}
              sectionName={"corporate"}
            />
            <CreateCard
              createSection={createPrivateItem}
              onChangeImage={onChangePrivateItem}
              formData={formDataPrivateItem}
              setFormData={setFormDataPrivateItem}
              sectionName={"private"}
            />
            <CreateCard
              createSection={createNonProfit}
              onChangeImage={onChangeNonProfit}
              formData={formDataNonProfit}
              setFormData={setFormDataNonProfit}
              sectionName={"nonProfit"}
            />
            <CreateCard
              createSection={createVip}
              onChangeImage={onChangeVip}
              formData={formDataVip}
              setFormData={setFormDataVip}
              sectionName={"vip"}
            />
          </CreatBlock>
        )}
      </CreateContainer>
    </>
  );
}

export default Main;
